import React from 'react';

// Thin horizontal ticker strip in brand color — visual rhythm between sections.
const BrandTape = ({ text = 'FITUR 2027 · MADRID · 20 ENE · MISIÓN INCUBATOUR' }) => (
    <div className="relative overflow-hidden border-y border-white/10 py-3 bg-[color:var(--brand)]">
        <div className="marquee">
            {[...Array(2)].map((_, k) => (
                <div key={k} className="flex items-center gap-8 pr-8">
                    {Array.from({ length: 6 }).map((_, i) => (
                        <React.Fragment key={`${k}-${i}`}>
                            <span className="text-white text-xs md:text-sm font-bold uppercase tracking-[0.22em] whitespace-nowrap">
                                {text}
                            </span>
                            <span className="text-white/60 text-xs">◆</span>
                        </React.Fragment>
                    ))}
                </div>
            ))}
        </div>
    </div>
);

export default BrandTape;
